"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-cj9dg5"
});

/**
 * NotFound Component.
 *
 * @param {Object} props React props
 * @param {String} props.noFoundText Content for not found results
 * @returns {React.ReactElement} NotFound Component
 * @public
 */
function NotFound({
  noFoundText = 'No positions match your search criteria, but please check back soon.',
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_paragraph.default, (0, _extends2.default)({
    text: noFoundText
  }, rest)));
}
NotFound.propTypes = {
  noFoundText: _propTypes.default.string
};